import confetti from "canvas-confetti";

/**
 * Centralized celebration helpers, keep confetti on-brand and consistent
 * wherever we want to reward the user. Every helper:
 *   • respects `prefers-reduced-motion` (particles off, logic still runs)
 *   • returns void (callers fire-and-forget)
 *   • uses the app's amber/pink/violet/emerald/sky palette
 *
 * Tiers (small → big) so we don't blow the same load on every win:
 *   celebrateSmall()  → one quick pop (regular wins, small rewards)
 *   celebrateMedium() → two-stage burst (streak, level-up, profile 50⭐)
 *   celebrateLarge()  → 4-stage cinematic burst (jackpot, milestones)
 */

const PALETTE = ["#FBBF24", "#F472B6", "#A78BFA", "#34D399", "#60A5FA"];
const BASE = { colors: PALETTE, ticks: 220, gravity: 0.9, scalar: 1.0, zIndex: 9999 };

const reducedMotion = () => {
  try { return !!window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches; }
  catch { return false; }
};

export const celebrateSmall = () => {
  if (reducedMotion()) return;
  confetti({ ...BASE, particleCount: 55, spread: 65, origin: { x: 0.5, y: 0.7 }, startVelocity: 38, scalar: 0.9 });
};

export const celebrateMedium = () => {
  if (reducedMotion()) return;
  confetti({ ...BASE, particleCount: 110, spread: 90, origin: { x: 0.5, y: 0.6 }, startVelocity: 45, scalar: 1.05 });
  setTimeout(() => confetti({ ...BASE, particleCount: 60, angle: 60, spread: 60, origin: { x: 0.1, y: 0.75 }, startVelocity: 50 }), 200);
  setTimeout(() => confetti({ ...BASE, particleCount: 60, angle: 120, spread: 60, origin: { x: 0.9, y: 0.75 }, startVelocity: 50 }), 320);
};

export const celebrateLarge = () => {
  if (reducedMotion()) return;
  // Central explosion
  confetti({ ...BASE, particleCount: 160, spread: 110, origin: { x: 0.5, y: 0.55 }, startVelocity: 50, scalar: 1.2 });
  // Staggered side cannons
  setTimeout(() => confetti({ ...BASE, particleCount: 80, angle: 60, spread: 70, origin: { x: 0.05, y: 0.7 }, startVelocity: 58 }), 180);
  setTimeout(() => confetti({ ...BASE, particleCount: 80, angle: 120, spread: 70, origin: { x: 0.95, y: 0.7 }, startVelocity: 58 }), 320);
  // Overhead sparkle shower
  setTimeout(() => confetti({ ...BASE, particleCount: 120, spread: 140, origin: { x: 0.5, y: 0.3 }, startVelocity: 32, gravity: 1.1, scalar: 0.85 }), 650);
  // Final trailing kiss
  setTimeout(() => confetti({ ...BASE, particleCount: 50, spread: 100, origin: { x: 0.5, y: 0.5 }, startVelocity: 25, scalar: 0.75 }), 1100);
};
